export const products = [
  {
    id: 1,
    slug: 'hdpe-tarpaulins',
    name: 'HDPE Tarpaulins',
    tagline: 'Ultimate Protection for Every Season',
    shortDesc: 'Premium heavy-duty covers crafted from 100% Virgin Quality HDPE, offering a superior strength-to-weight ratio for agriculture, construction, and logistics.',
    heroImage: require('@/assets/products/hdpe/hdpe-1.png'),
    images: [
      require('@/assets/products/hdpe/hdpe-1.png'),
      require('@/assets/products/hdpe/hdpe-2.png'),
      require('@/assets/products/hdpe/hdpe-3.png'),
      require('@/assets/products/hdpe/hdpe-4.png'),
    ],
    pricePdf: '/pdfs/hdpe-price.pdf',
    pricePdfLabel: 'Download HDPE Price List',
    category: 'Tarpaulins',
    badge: 'Best Seller',
    badgeColor: '#F59E0B',
    intro: `Protect your valuable assets with premium KeBee Tarpaulins, engineered for maximum durability and long-term performance. Crafted from 100% Virgin Quality HDPE (High-Density Polyethylene), our covers provide a superior strength-to-weight ratio that recycled alternatives simply cannot match. Whether you are shielding agricultural produce, construction equipment, or outdoor vehicles, KeBee offers a reliable barrier against the harshest elements.`,
    features: [
      {
        icon: 'bi-droplet-fill',
        color: '#3B82F6',
        title: 'Complete Weatherproofing',
        desc: 'Every KeBee Tarpaulin is designed to be 100% Waterproof, ensuring your goods stay bone-dry even during torrential downpours.',
      },
      {
        icon: 'bi-sun-fill',
        color: '#F59E0B',
        title: 'UV Stabilized Technology',
        desc: 'Integrated UV inhibitors prevent degradation, cracking, and fading caused by prolonged sun exposure, significantly extending product lifespan.',
      },
      {
        icon: 'bi-shield-lock-fill',
        color: '#10B981',
        title: 'Reinforced Anchoring',
        desc: 'Strong aluminum eyelets placed every 1 meter, with 2 specialized eyelets at every corner across all sizes for maximum stability.',
      },
      {
        icon: 'bi-star-fill',
        color: '#8B5CF6',
        title: 'Virgin Grade Material',
        desc: '100% Virgin HDPE ensures better flexibility, higher tear resistance, and a clean, professional finish — unmatched by recycled alternatives.',
      },
    ],
    applications: [
      { icon: 'bi-tree-fill', text: 'Agricultural produce cover' },
      { icon: 'bi-building-fill', text: 'Construction site protection' },
      { icon: 'bi-truck-front-fill', text: 'Vehicle and truck covers' },
      { icon: 'bi-house-fill', text: 'Temporary roof covers' },
      { icon: 'bi-boxes', text: 'Outdoor equipment storage' },
      { icon: 'bi-umbrella-fill', text: 'Monsoon shielding' },
    ],
    specsTitle: 'Versatile GSM Options',
    specsDesc: 'A comprehensive range of thicknesses to suit everything from light-weight domestic use to extreme industrial applications:',
    specs: [
      { col1: '125 – 150 GSM', col2: 'Light-weight covering, camping, and basic dust protection.' },
      { col1: '200 – 250 GSM', col2: 'Medium-duty use, monsoon protection, and vehicle covers.' },
      { col1: '300 – 350 GSM', col2: 'Heavy-duty industrial shielding and long-term outdoor storage.' },
      { col1: '425 GSM', col2: 'Extra heavy-duty for extreme weather and rugged site protection.' },
    ],
    specHeaders: ['GSM Grade', 'Recommended Use Case'],
    whySection: 'Our manufacturing process focuses on high-tensile strength and heat-sealed edges to prevent fraying. The rust-proof aluminum eyelets ensure that your fastening points remain intact even in coastal or humid environments. From the smallest backyard project to massive industrial logistics, KeBee Tarpaulins provides the "Gold Standard" in protective covering.',
  },

  {
    id: 2,
    slug: 'pvc-fr-tarpaulins',
    name: 'PVC-Coated Fire-Retardant Tarpaulins',
    tagline: 'The Shield of Safety',
    shortDesc: 'Engineered for high-risk environments — self-extinguishing, 100% waterproof, and built to comply with the most rigorous international fire safety standards.',
    heroImage: require('@/assets/products/pvc-fr/pvc-fr-1.png'),
    images: [
      require('@/assets/products/pvc-fr/pvc-fr-1.png'),
      require('@/assets/products/pvc-fr/pvc-fr-2.png'),
      require('@/assets/products/pvc-fr/pvc-fr-3.png'),
    ],
    pricePdf: '/pdfs/pvc-fr-price.pdf',
    pricePdfLabel: 'Download PVC-FR Price List',
    secondaryPdf: '/pdfs/pvc-price.pdf',
    secondaryPdfLabel: 'PVC Coated Tarpaulin Price List',
    category: 'Tarpaulins',
    badge: 'Safety Certified',
    badgeColor: '#EF4444',
    intro: `When high-risk environments demand more than just a cover, KeBee Tarpaulins delivers with our premium PVC-Coated Fire-Retardant range. These aren't just waterproof; they are engineered for safety, designed to resist ignition and prevent the spread of flames. Whether you are working in high-heat industrial zones, public events, or chemical storage, KeBee provides a professional-grade safety barrier that meets the most rigorous standards.`,
    features: [
      {
        icon: 'bi-fire',
        color: '#EF4444',
        title: 'Fire-Retardant Protection',
        desc: 'Specially treated PVC coating designed to be self-extinguishing, offering critical protection in fire-prone areas.',
      },
      {
        icon: 'bi-droplet-half',
        color: '#3B82F6',
        title: '100% Waterproof & Leak-Proof',
        desc: 'Heat-welded seams provide a total moisture barrier for sensitive equipment and inventory.',
      },
      {
        icon: 'bi-shield-fill-check',
        color: '#10B981',
        title: 'Industrial Strength',
        desc: 'PVC coating bonded to high-tenacity polyester base fabric — incredibly resistant to punctures, abrasions, and tearing.',
      },
      {
        icon: 'bi-sun-fill',
        color: '#F59E0B',
        title: 'UV & Weather Shield',
        desc: 'UV stabilized to withstand extreme sun exposure without cracking or peeling, ensuring a long service life.',
      },
    ],
    applications: [
      { icon: 'bi-building-fill', text: 'Construction site enclosures' },
      { icon: 'bi-shop-window', text: 'Event tents & marquees' },
      { icon: 'bi-truck-front-fill', text: 'Truck and trailer covers' },
      { icon: 'bi-gear-fill', text: 'Oil & gas site protection' },
      { icon: 'bi-box-seam', text: 'Warehouse curtains & screens' },
      { icon: 'bi-hammer', text: 'Welding screens & partitions' },
    ],
    specsTitle: 'KeBee PVC GSM Selection',
    specsDesc: 'Choose the perfect weight for your specific safety and structural requirements:',
    specs: [
      { col1: '450 GSM', col2: 'Light industrial covers, temporary partitions, and equipment shrouds.' },
      { col1: '550 GSM', col2: 'Warehouse curtains, welding screens, and medium-duty truck covers.' },
      { col1: '650 GSM', col2: 'Heavy-duty construction enclosures and large-scale marquee roofing.' },
      { col1: '750 GSM', col2: 'Extreme-duty industrial protection, oil & gas sites, and long-term storage.' },
    ],
    specHeaders: ['GSM Grade', 'Ideal Applications'],
    whySection: 'At KeBee, we understand that fire safety is non-negotiable. Our PVC-coated tarpaulins are manufactured with 100% Virgin Quality polymers, resulting in a smooth, easy-to-clean finish that resists oil, chemicals, and mildew. When the stakes are high, trust KeBee Tarpaulins to keep your site, your assets, and your people protected.',
  },

  {
    id: 3,
    slug: 'canvas-tarpaulin',
    name: 'Canvas Tarpaulin',
    tagline: 'The Premium Choice for Rugged Protection',
    shortDesc: 'Mumbai-made 100% Cotton Single Duck canvas tarpaulins — breathable, high-absorption, and eco-friendly for industrial, transit, and painting applications.',
    heroImage: require('@/assets/products/canvas/canvas-1.png'),
    images: [
      require('@/assets/products/canvas/canvas-1.png'),
      require('@/assets/products/canvas/canvas-2.png'),
      require('@/assets/products/canvas/canvas-3.png'),
      require('@/assets/products/canvas/canvas-4.png'),
    ],
    pricePdf: '/pdfs/canvas-price.pdf',
    pricePdfLabel: 'Download Canvas Price List',
    category: 'Tarpaulins',
    badge: 'Eco-Friendly',
    badgeColor: '#10B981',
    intro: `KeBee Tarpaulins stands as a leading manufacturer of high-quality Cotton Canvas Tarpaulins, continuing a tradition of heavy-duty reliability right here in Mumbai. Engineered for specialized industrial and transit needs, our canvas range offers the unique "breathable" protection that synthetic covers simply cannot provide.`,
    features: [
      {
        icon: 'bi-layers-half',
        color: '#92400E',
        title: '100% Cotton Single Duck Fabric',
        desc: 'Every KeBee Canvas tarp is woven from premium, high-density cotton duck, ensuring a natural, rugged texture that stands up to heavy wear and tear.',
      },
      {
        icon: 'bi-droplet-fill',
        color: '#3B82F6',
        title: 'Superior Absorption Power',
        desc: 'Designed to absorb moisture, paints, and oils — the essential choice for painting contractors, industrial floors, and sensitive cargo.',
      },
      {
        icon: 'bi-wind',
        color: '#10B981',
        title: 'Breathable Shielding',
        desc: 'Natural fibers allow air to circulate, preventing condensation and rust buildup on machinery or equipment stored underneath.',
      },
      {
        icon: 'bi-recycle',
        color: '#059669',
        title: 'Eco-Friendly & Sustainable',
        desc: 'Made from natural fibers, KeBee Canvas provides a durable solution that is more environmentally conscious for long-term use.',
      },
    ],
    applications: [
      { icon: 'bi-truck-front-fill', text: 'Transport & logistics flatbeds' },
      { icon: 'bi-paint-bucket', text: 'Industrial painting & refurbishment' },
      { icon: 'bi-gear-fill', text: 'Machinery storage & dust covers' },
      { icon: 'bi-box-seam', text: 'Sensitive cargo protection' },
      { icon: 'bi-house-fill', text: 'Construction floor protection' },
      { icon: 'bi-tree-fill', text: 'Agricultural and outdoor use' },
    ],
    specsTitle: 'KeBee Quality Grades',
    specsDesc: 'Two distinct professional qualities to match your specific requirements:',
    specs: [
      { col1: 'Water-Repellent Grade', col2: 'Treated with specialized wax and chemical coatings to shed water while maintaining the classic canvas feel.' },
      { col1: 'Natural / Unshielded Grade', col2: 'Pure, untreated single-duck fabric — perfect for indoor dust protection and heavy-duty absorption tasks.' },
    ],
    specHeaders: ['Grade', 'Description & Best Use'],
    whySection: 'At KeBee Tarpaulins, we take pride in our Mumbai-based manufacturing heritage. We ensure that every seam is reinforced and every eyelet is set with precision, delivering a product that lives up to the heavy-duty demands of the Indian industrial market. For protection that breathes and lasts, choose the KeBee Canvas standard.',
  },

  {
    id: 4,
    slug: 'agro-shade-nets',
    name: 'Agro Shade Nets',
    tagline: 'Precision Climate Control for Your Crops',
    shortDesc: 'Professional-grade UV-stabilized shade nets crafted from 100% Virgin HDPE — protecting crops, reducing temperature, and boosting yield for modern farmers.',
    heroImage: require('@/assets/products/agro/agro-1.png'),
    images: [
      require('@/assets/products/agro/agro-1.png'),
      require('@/assets/products/agro/agro-2.png'),
      require('@/assets/products/agro/agro-3.png'),
      require('@/assets/products/agro/agro-4.jpg'),
      require('@/assets/products/agro/agro-5.jpg'),
      require('@/assets/products/agro/agro-6.jpg'),
    ],
    pricePdf: '/pdfs/agro-price.pdf',
    pricePdfLabel: 'Download Agro Net Price List',
    category: 'Agriculture',
    badge: 'Farmer\'s Choice',
    badgeColor: '#10B981',
    intro: `Cultivate success with the professional-grade range of KeBee Agro Shade Nets and Packaging Nets. Engineered specifically for the modern farmer and commercial nursery, our nets are manufactured from 100% Virgin HDPE to provide unmatched strength and longevity. By combining high-density polymers with specialized color masterbatches and advanced Ultra-Violet (UV) stabilizers, KeBee ensures your crops are shielded from scorching heat while maintaining the perfect micro-climate for growth.`,
    features: [
      {
        icon: 'bi-shield-fill-check',
        color: '#F59E0B',
        title: 'UV Shield Technology',
        desc: 'Chemically stabilized to resist sun degradation — nets don\'t become brittle or lose their color even after years of exposure.',
      },
      {
        icon: 'bi-thermometer-low',
        color: '#3B82F6',
        title: 'Climate Optimization',
        desc: 'Classified by precise shade percentages, allowing you to control exactly how much sunlight reaches your plants.',
      },
      {
        icon: 'bi-grid-3x3-gap-fill',
        color: '#10B981',
        title: 'Tear-Resistant Weave',
        desc: 'Lock-stitch pattern that prevents fraying and allows for easy installation over various structural frames.',
      },
      {
        icon: 'bi-star-fill',
        color: '#8B5CF6',
        title: 'Virgin Quality HDPE',
        desc: '100% virgin material ensures the nets remain lightweight yet incredibly durable against wind and physical tension.',
      },
    ],
    applications: [
      { icon: 'bi-flower1', text: 'Greenhouses & nurseries' },
      { icon: 'bi-tree-fill', text: 'Agriculture fields' },
      { icon: 'bi-house-door-fill', text: 'Home gardens' },
      { icon: 'bi-egg-fried', text: 'Poultry sheds' },
      { icon: 'bi-building-fill', text: 'Construction dust barriers' },
      { icon: 'bi-box-seam', text: 'Fencing & general shielding' },
    ],
    specsTitle: 'Shade Percentages & Color Options',
    specsDesc: 'Tailored shading solutions based on the sensitivity of your specific crops:',
    specs: [
      { col1: '50% Shade Net', col2: 'Ideal for sun-loving vegetables, general nursery stock, and hardy flowering plants.' },
      { col1: '75% Shade Net', col2: 'Perfect for moderate-light plants, leafy greens, and protecting livestock from direct heat.' },
      { col1: '90% Shade Net', col2: 'Best for high-sensitivity crops (orchids, ferns), poultry sheds, and construction dust barriers.' },
    ],
    specHeaders: ['Shade Grade', 'Ideal Applications'],
    colorOptions: [
      { name: 'Green', desc: 'Industry standard for nurseries and agricultural cooling.' },
      { name: 'Red', desc: 'Stimulates specific growth cycles, enhances fruit/flower quality.' },
      { name: 'Cream', desc: 'High-end look with soft, diffused light.' },
      { name: 'Multicolor', desc: 'Highly visible, durable — perfect for fencing and general shielding.' },
    ],
    whySection: 'At KeBee Tarpaulins, we understand that your harvest is your livelihood. Our Agro Shade Nets go beyond simple covering — they act as a protective barrier against birds, heavy winds, and hail, while significantly reducing water evaporation. When you invest in KeBee, you are investing in the health and yield of your farm.',
  },

  {
    id: 5,
    slug: 'barsati-plastic',
    name: 'Barsati Plastic',
    tagline: 'Cost-Effective Protection for Every Monsoon',
    shortDesc: 'High-quality black/white polyethylene sheeting for rapid deployment — the go-to choice for wedding mandaps, monsoon sheds, construction sites, and seasonal covers.',
    heroImage: require('@/assets/products/barsati/barsati-1.png'),
    images: [
      require('@/assets/products/barsati/barsati-1.png'),
      require('@/assets/products/barsati/barsati-2.png'),
      require('@/assets/products/barsati/barsati-3.png'),
    ],
    pricePdf: '/pdfs/barsati-price.pdf',
    pricePdfLabel: 'Download Barsati Plastic Price List',
    category: 'Plastic Sheeting',
    badge: 'Budget Friendly',
    badgeColor: '#3B82F6',
    intro: `When you need immediate, reliable, and budget-friendly shielding from the elements, KeBee Tarpaulins offers high-quality "Barsati Plastic" (also widely known as Black Plastic). Specially engineered for rapid deployment against rain and sun, our Barsati range provides a versatile alternative for projects where speed and cost-efficiency are the top priorities.`,
    features: [
      {
        icon: 'bi-cloud-rain-fill',
        color: '#3B82F6',
        title: 'Optimized for Weather Protection',
        desc: 'Specifically formulated to repel heavy rainfall and provide essential shade from harsh sunlight.',
      },
      {
        icon: 'bi-lightning-charge-fill',
        color: '#F59E0B',
        title: 'Superior Flexibility',
        desc: 'Lighter in weight compared to traditional HDPE tarpaulins, making it incredibly easy to handle, fold, and install.',
      },
      {
        icon: 'bi-star-fill',
        color: '#8B5CF6',
        title: '100% Virgin Quality',
        desc: 'Unlike standard scrap-based plastics, our KeBee Barsati is made from virgin polymers for better stretch-resistance and longer seasonal lifespan.',
      },
      {
        icon: 'bi-currency-rupee',
        color: '#10B981',
        title: 'Cost-Effective Shielding',
        desc: 'Perfect for temporary setups — providing professional-grade protection without the heavy industrial price tag.',
      },
    ],
    applications: [
      { icon: 'bi-cloud-drizzle-fill', text: 'Monsoon sheds & outdoor storage' },
      { icon: 'bi-balloon-heart-fill', text: 'Wedding mandaps & events' },
      { icon: 'bi-building-fill', text: 'Construction site coverings' },
      { icon: 'bi-tree-fill', text: 'Agricultural ground lining' },
      { icon: 'bi-box-fill', text: 'Temporary crop protection' },
      { icon: 'bi-tools', text: 'Quick temporary setups' },
    ],
    specsTitle: 'Product Details',
    specsDesc: 'KeBee Barsati Plastic is manufactured with consistent thickness throughout the roll — no weak spots, no pinholes:',
    specs: [
      { col1: 'Material', col2: '100% Virgin Polyethylene' },
      { col1: 'Colors', col2: 'Black / Black & White' },
      { col1: 'Usage Type', col2: 'Temporary / Seasonal' },
      { col1: 'Weight', col2: 'Lighter than HDPE tarpaulins' },
    ],
    specHeaders: ['Property', 'Details'],
    whySection: 'At KeBee Tarpaulins, we believe temporary shouldn\'t mean "flimsy." Our Black Barsati Plastic is manufactured with consistent thickness throughout the roll, ensuring there are no weak spots or pinholes. For a quick, effective, and economical barrier against the rain, trust the name that stands for quality: KeBee.',
  },

  {
    id: 6,
    slug: 'nylon-ropes',
    name: 'Nylon Ropes',
    tagline: 'High-Strength Solutions for Every Pull',
    shortDesc: 'Manufactured from 100% Virgin High-Tenacity Polyamide — extreme strength, shock absorption, rot-proof, and UV resistant for cargo securing, marine, and industrial use.',
    heroImage: require('@/assets/products/nylon/nylon-1.png'),
    images: [
      require('@/assets/products/nylon/nylon-1.png'),
      require('@/assets/products/nylon/nylon-2.png'),
      require('@/assets/products/nylon/nylon-3.jpg'),
    ],
    pricePdf: null,
    pricePdfLabel: null,
    category: 'Accessories',
    badge: 'Complete System',
    badgeColor: '#6366F1',
    intro: `When your project demands a combination of extreme strength, flexibility, and shock absorption, KeBee Nylon Ropes are the professional's choice. Manufactured from 100% Virgin High-Tenacity Polyamide, our ropes are engineered to handle heavy loads while maintaining a smooth, easy-to-handle texture. Whether you are securing a cargo load with a KeBee Tarpaulin or managing a complex industrial lift, our nylon ropes provide the reliability you need.`,
    features: [
      {
        icon: 'bi-lightning-charge-fill',
        color: '#F59E0B',
        title: 'Superior Shock Absorption',
        desc: 'KeBee Nylon is famous for its elasticity — stretches and absorbs sudden energy loads without breaking, perfect for towing and anchoring.',
      },
      {
        icon: 'bi-sun-fill',
        color: '#EF4444',
        title: 'UV & Abrasion Resistant',
        desc: 'Treated to withstand prolonged exposure to sunlight and harsh friction, ensuring the rope doesn\'t fray or weaken over time.',
      },
      {
        icon: 'bi-shield-fill-check',
        color: '#10B981',
        title: '100% Rot & Chemical Proof',
        desc: 'Naturally resistant to oil, gasoline, and most chemicals — ideal for marine, automotive, and industrial environments.',
      },
      {
        icon: 'bi-bar-chart-fill',
        color: '#3B82F6',
        title: 'High Tensile Strength',
        desc: 'Despite their flexibility, these ropes offer one of the highest weight-bearing capacities in the synthetic fiber family.',
      },
    ],
    applications: [
      { icon: 'bi-truck-front-fill', text: 'Tarpaulin lashing & cargo securing' },
      { icon: 'bi-water', text: 'Marine mooring & boat anchoring' },
      { icon: 'bi-building-fill', text: 'Construction utility work' },
      { icon: 'bi-gear-fill', text: 'Industrial lifting & safety lines' },
      { icon: 'bi-car-front-fill', text: 'Automotive towing' },
      { icon: 'bi-tree-fill', text: 'Agricultural bundling' },
    ],
    specsTitle: 'Versatile Size Range (4mm to 30mm)',
    specsDesc: 'From precision lashing to heavy-duty industrial hauling, KeBee offers the exact diameter for your specific task:',
    specs: [
      { col1: '4mm – 8mm', col2: 'Lashing tarpaulins, camping, clotheslines, and light bundling.' },
      { col1: '10mm – 16mm', col2: 'General construction, utility work, and medium-weight securing.' },
      { col1: '18mm – 24mm', col2: 'Industrial lifting, safety lines, and heavy truck tie-downs.' },
      { col1: '26mm – 30mm', col2: 'Marine mooring, heavy machinery towing, and extreme-load hauling.' },
    ],
    specHeaders: ['Diameter Range', 'Typical Applications'],
    whySection: 'At KeBee, we don\'t compromise on safety. Our ropes feature a precision-braid or twist construction that ensures uniform diameter and consistent strength throughout the entire length. When you pair a KeBee Tarpaulin with our Nylon Ropes, you are investing in a complete, professional-grade protection system that is built to last.',
  },
]

export const getProductBySlug = (slug) => products.find(p => p.slug === slug)
